import { render, staticRenderFns } from "./WhitelistsView.vue?vue&type=template&id=5f120543&"
import script from "./WhitelistsView.vue?vue&type=script&lang=js&"
export * from "./WhitelistsView.vue?vue&type=script&lang=js&"
import style0 from "./WhitelistsView.vue?vue&type=style&index=0&id=5f120543&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports